import index from './prebid-config';

export default index;
